import React, {useEffect, useState} from 'react';
import {Box, Pagination} from '@mui/material';
import {CustomButton, Spinner} from '../../components';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {getPdfReports} from '../../actions';
import PdfsReportTable from '../../components/CustomTables/PdfReportsTable';
import {sendPdfByMail} from '../../actions/pdfReportsActions';
import generatePDFBlob from './PDF/util/generatePdfBlob';
import moment from 'moment';

const ElevatorServicesTab = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    elevatorReports,
    elevatorsReportsPage,
    elevatorsReportsTotalPages,
    pdfLoading,
    emailSending,
  } = useSelector(s => s.pdfReports);
  const {user} = useSelector(s => s.user);

  const [isLoading, setIsLoading] = useState(false);
  const [pdfBlob, setPdfBlob] = useState(null);

  const onPageChange = (e, value) => {
    dispatch(getPdfReports({page: value, templateType: 'ELEVATOR'}));
  };

  const getSerialNumber = () => {
      const currentSerial = localStorage.getItem('serialNo') || '001';
      const currentMonth = moment().format('MM');
      const currentYear = moment().format('YY');
      const fullSerial = `${currentSerial}${currentMonth}${currentYear}`;
  
      return fullSerial;
    };

  const addReport = () => {
    navigate('/services/add-elevator-report');
  };

  const onRowClick = obj => {
    const payload = {ordinalNr: getSerialNumber(), ...JSON.parse(obj.payload)};
    navigate(`/elevator_services_pdf`, {state: payload});
  };
  const [signatureUrl, setSignatureUrl] = useState(null);
  useEffect(() => {
    const storedSignatureUrl = localStorage.getItem('signatureUrl');
    if (storedSignatureUrl) {
      setSignatureUrl(storedSignatureUrl);
    }
  }, []);

  const handleSendEmail = async obj => {
    const payload = {ordinalNr: getSerialNumber(), ...JSON.parse(obj.payload)};
    const blob = await generatePDFBlob(payload, signatureUrl);
    setPdfBlob(blob);
    if (!pdfBlob) {
      alert('PDF is not generated yet.');
      return;
    }
    const formData = new FormData();
    formData.append('reportId', obj.id);
    formData.append('email', user?.email);
    formData.append('attachment', pdfBlob, 'elevator_service_report.pdf');

    // Dispatch action with formData as payload
    dispatch(sendPdfByMail(formData));
  };

  useEffect(() => {
    dispatch(getPdfReports({templateType: 'ELEVATOR'}));
  }, [dispatch]);

  if (emailSending) {
    return (
    <div>
      <h3>Sending email  .....</h3>
      <Spinner />;
    </div>
    )
  }
  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb="1rem">
        <CustomButton onClick={addReport}>Add elevator report</CustomButton>
      </Box>
      <PdfsReportTable
        list={elevatorReports}
        loading={pdfLoading}
        onRowClick={onRowClick}
        handleSendEmail={handleSendEmail}
      />
      {elevatorsReportsTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={elevatorsReportsTotalPages}
            page={elevatorsReportsPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </Box>
  );
};

export default ElevatorServicesTab;
